import { render, staticRenderFns } from "./areaNavs.vue?vue&type=template&id=38b4ec65&scoped=true&"
import script from "./areaNavs.vue?vue&type=script&lang=js&"
export * from "./areaNavs.vue?vue&type=script&lang=js&"
import style0 from "./areaNavs.vue?vue&type=style&index=0&id=38b4ec65&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_@vue+com_158fd1d6ef9e4cc6d0695d4cab9c983b/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b4ec65",
  null
  
)

export default component.exports